module.exports = "./assets/assets/相关政策依据.0e45bf26.docx";